/**
 * Request Notes Section Component
 *
 * @module @features/requests/components/RequestDetails/components/RequestNotes
 */

import React from 'react';
import { useI18n } from '@shared/i18n';
import type { Request } from '@features/requests/types';
import styles from '../RequestDetails.module.css';

/**
 * Props for RequestNotes component
 */
export interface RequestNotesProps {
    request: Request;
}

/**
 * Displays request notes
 */
export function RequestNotes({
    request,
}: RequestNotesProps): React.ReactElement | null {
    const { t } = useI18n();

    if (!request.notes) return null;

    return (
        <div className={styles.section}>
            <h3 className={styles.sectionTitle}>
                {t('requests.details.notes')}
            </h3>
            <p className={styles.notes}>{request.notes}</p>
        </div>
    );
}
